import NoInquiry from './NoInquiry'

export default NoInquiry
